import React from "react";
import { StickAndCircleBlock } from "../molecules/StickAndCircleBlock";
import {
  getCarIcon,
  getIconMovingArrow,
  removeCityFromAddr,
} from "../logics/garbageCollectionPoints";

interface IPointListItem {
  isClickedPoint: boolean; //эта точка, на которую нажали на карте
  carPlace: number; //находиться ли машина в данной точке(CarNotHere, CarHereAndMovingUp или CarHereAndMovingDown)
  isLast: boolean; //если данный элемент последний в списке
  address: string; //адрес точки
}

export const CarHereAndMovingDown = 1; //машина в данной точке и движеться вниз(к концу списка)
export const CarHereAndMovingUp = 2; //машина в данной точке и движеться верх(к началу списка)
export const CarNotHere = 3; //в данной точке машины нет

//отрисовываем элемент из списка точек в маршруте
export const PointListItem = ({
  isLast,
  isClickedPoint,
  carPlace,
  address,
}: IPointListItem) => {
  const noCarMark = carPlace === CarNotHere;
  //const rotate = carPlace == CarHereAndMovingUp ? "0deg" : "rotate(180deg)"
  const visible = noCarMark ? "invisible" : "";
  console.log(
    "PLI:",
    carPlace,
    CarHereAndMovingUp,
    carPlace === CarHereAndMovingUp
  );
  return (
    <li className={ "route-li " + (isClickedPoint ? "clicked-elem" : "")}>
      <div className={"route-li__icons " + visible}>
        <img src={getCarIcon()} alt="иконка авто" />
        <img
          src={getIconMovingArrow()}
          alt=""
          className="ml-1"
          style={{ transform: "rotate(180deg)" }}
        />
      </div>
      <StickAndCircleBlock
        isClickedPoint={isClickedPoint}
        isBusHere={!noCarMark}
        isLast={isLast}
      />
      <p
        className={
          isClickedPoint
            ? "route-li__address route-li__address_active"
            : "route-li__address"
        }
      >
        {removeCityFromAddr(address)}
      </p>
    </li>
  );
};
